import { html, LitElement, PropertyValues } from 'lit';
import { state, property } from 'lit/decorators.js';
import { styles } from '../view/styles';

export class GzProgressWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({
    type: Number,
    reflect: true,
  })
  valueNow = 0;

  @property({ type: Number })
  valueMax = 0;

  @property({ type: String })
  progressColor = 'var(--blue-layout-400-primary)';

  @property({
    type: Boolean,
    reflect: true,
  })
  animations = true;

  @state()
  private percentage = 0;

  @state()
  private minWidth = 0;

  constructor() {
    super();
  }

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    const style = `
      width: ${this.percentage}%;
      min-width: ${this.minWidth}px;
      background-color: ${this.progressColor};
    `;
    return html`
      <div class="progress-container">
        <div class="progress" style="${style}"></div>
      </div>
    `;
  }

  updated(changedProperties: PropertyValues): void {
    if (changedProperties.has('valueNow') || changedProperties.has('valueMax')) {
      if (this.animations) {
        /** When the component is added to the DOM we show the progress as
         *  empty, with valueNow = 0, then update the valueNow variable with the
         *  value passed from the component's parent. The width property on the
         *  progress element is animated and will show a smooth transition from 0 ->
         *  valueNow.
         */
        this.updateProgressBar(0, this.valueMax);

        setTimeout(() => {
          this.updateProgressBar(this.valueNow, this.valueMax);
        }, 800);
      } else {
        this.updateProgressBar(this.valueNow, this.valueMax);
      }
    }
  }

  updateProgressBar(value: number, total: number) {
    this.percentage = (100 * value) / total || 0;
    /**
     * if the progress value > 0 but is very small in comparison with the
     * total we need to set a minimum width of 1px for the progress bar so
     * it will be always visible even for very small values;
     */
    this.minWidth = value > 0 ? 1 : 0;
  }
}
